/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Label_PushInputs */

const en_us2_plan_label_push = /** @type {(inputs: Plan_Label_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push`)
};

const pt_br2_plan_label_push = /** @type {(inputs: Plan_Label_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar`)
};

const es_419_plan_label_push = /** @type {(inputs: Plan_Label_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empuje`)
};

const pt_pt2_plan_label_push = /** @type {(inputs: Plan_Label_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar`)
};

const fr_fr2_plan_label_push = /** @type {(inputs: Plan_Label_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poussée`)
};

const de_de2_plan_label_push = /** @type {(inputs: Plan_Label_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drücken`)
};

const it_it2_plan_label_push = /** @type {(inputs: Plan_Label_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spinta`)
};

/**
* | output |
* | --- |
* | "Push" |
*
* @param {Plan_Label_PushInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_label_push = /** @type {((inputs?: Plan_Label_PushInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Label_PushInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_label_push(inputs)
	if (locale === "es-419") return es_419_plan_label_push(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_label_push(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_label_push(inputs)
	if (locale === "de-DE") return de_de2_plan_label_push(inputs)
	if (locale === "it-IT") return it_it2_plan_label_push(inputs)
	return en_us2_plan_label_push(inputs)
});
export { plan_label_push as "plan.label_push" }